import styled from 'styled-components';
import { memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  Paper
} from '@mui/material';
import proIcon from 'assets/img/bottomNav/profile_inactive.svg';
import notificationIcon from 'assets/img/bottomNav/notification_inactive.svg';
import scanIcon from 'assets/img/bottomNav/scan_inactive.svg';
import homeIcon from 'assets/img/bottomNav/home_inactive.svg';
import activeProIcon from 'assets/img/bottomNav/profile_active.svg';
import activeNotificationIcon from 'assets/img/bottomNav/notification_active.svg';
import activeScanIcon from 'assets/img/bottomNav/scan_active.svg';
import activeHomeIcon from 'assets/img/bottomNav/home_active.svg';
import listIcon from 'assets/img/bottomNav/list/list.svg';
import activeListIcon from 'assets/img/bottomNav/list/listActive.svg';
import { useScrollDirection } from 'hooks/usePageScrollDir';
import ScanButton from 'modules/components/common/button/scan-button';
import { NotificationBadge } from 'modules/components/common/notification-badge/badge';

const tabs = [
  {
    index: 0,
    route: '/app/profile',
    label: 'Profile',
    imgSrc: proIcon,
    activeImgSrc: activeProIcon
  },
  {
    index: 1,
    type: 'notif',
    route: '/app/notification',
    label: 'Notification',
    imgSrc: notificationIcon,
    activeImgSrc: activeNotificationIcon
  },
  {
    index: 2,
    route: '/app/scan',
    label: 'Scan',
    imgSrc: scanIcon,
    activeImgSrc: activeScanIcon
  },
  {
    index: 3,
    route: '/app/list',
    label: 'Patient List',
    imgSrc: listIcon,
    activeImgSrc: activeListIcon
  },
  {
    index: 4,
    route: '/app/home',
    label: 'Dashboard',
    imgSrc: homeIcon,
    activeImgSrc: activeHomeIcon
  }
];

function SimpleBottomNavigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pageScrollDir = useScrollDirection();

  const navigationClick = (event, item) => {
    event.preventDefault();
    navigate(item.route);
  };

  const LabelComponent = ({ isActive, label }) => {
    return <Label isActive={isActive}>{label}</Label>;
  };

  const activeTab = tabs.find((item) => item.route === pathname);

  const hiddenRoutes = ['/app/edit', '/app/faq'];
  const hideNav =
    hiddenRoutes.filter((item) => item === pathname).length > 0 ? true : false;

  const hideOnScrollRoutes = ['/app/list', '/app/report'];
  const findHideOnScrollRoutes =
    hideOnScrollRoutes.filter((item) => item === pathname).length > 0
      ? true
      : false;

  return (
    <Container
      key={pathname}
      display={!hideNav}
      hideOnScroll={
        pageScrollDir === 'up' && findHideOnScrollRoutes ? true : false
      }
    >
      {!hideNav && (
        <Paper className="paper" elevation={3}>
          <BottomNavigation className="bottom-nav">
            <Grid container>
              {tabs.map((item, index) => {
                const isActive = activeTab?.index === item.index;
                return item.index === 2 ? (
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'end'
                    }}
                    xs={2}
                    key={index}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '26px'
                      }}
                    >
                      <ScanButton
                        isActive={isActive}
                        item={item}
                        route={item.route}
                      />
                    </div>
                    <div style={{ paddingBottom: '8px' }}>
                      <LabelComponent isActive={isActive} label={item.label} />
                    </div>
                  </Grid>
                ) : (
                  <BottomNavigationAction
                    key={index}
                    component={Link}
                    to={item.route}
                    showLabel
                    label={
                      <LabelComponent isActive={isActive} label={item.label} />
                    }
                    icon={
                      <div style={{ position: 'relative' }}>
                        <img
                          className={item.onboardKey}
                          src={isActive ? item.activeImgSrc : item.imgSrc}
                          alt=""
                        />
                        {item.type === 'notif' && <NotificationBadge />}
                      </div>
                    }
                    onClick={(event) => navigationClick(event, item)}
                  />
                );
              })}
            </Grid>
          </BottomNavigation>
        </Paper>
      )}
    </Container>
  );
}

export default memo(SimpleBottomNavigation);

const Label = styled.div`
  color: ${({ isActive }) => (isActive ? '#753CBE !important' : '#707070')};
  font-weight: 400;
  font-size: 8px;
  text-align: center;
  color: #707070;
`;
const Container = styled.div`
  visibility: ${({ hideOnScroll }) => (hideOnScroll ? 'hidden' : 'visible')};
  .paper {
    transition: all 0.5s;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.85) !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    backdrop-filter: blur(3px) !important;
    height: 56px !important;
    z-index: 100 !important;
    transform: ${({ hideOnScroll }) =>
      hideOnScroll ? 'translateY(150%)' : ''};
  }
  .bottom-nav {
    background-color: transparent !important;
  }
  .bottom-nav a {
    max-width: none;
    min-width: unset;
  }
  .bottom-nav a:focus,
  .bottom-nav a:active {
    -webkit-tap-highlight-color: transparent;
  }
`;
